module.exports = __webpack_public_path__ + "static/media/tag_augmented_games.7934db5f.svg";